// extracted by mini-css-extract-plugin
export default {"speNav":"index_speNav_YGdaz"};